import Dialog from "@mui/material/Dialog";
import "./confirmDialog.scss";

// Reusable V2 confirmation dialog: title, body, primary pill action,
// optional secondary text action, X close. Brand styling via --v2-* tokens only.
// `danger` turns the primary pill red for destructive actions (e.g. cancel order).
// `dismissible={false}` removes the X and ignores backdrop/Esc — the only ways
// out are the explicit actions (e.g. the not-eligible-to-buy-a-pass block).
function ConfirmDialog({
  isOpen,
  onClose,
  title,
  body,
  primaryText,
  onPrimary,
  secondaryText,
  onSecondary,
  danger,
  dismissible = true,
}) {
  return (
    <Dialog
      open={isOpen}
      onClose={dismissible ? onClose : undefined}
      disableEscapeKeyDown={!dismissible}
      classes={{ paper: "v2-confirm-dialog" }}
    >
      {dismissible && (
        <button type="button" className="v2-confirm-dialog-close" onClick={onClose} aria-label="close">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      )}

      {title && <p className="v2-confirm-dialog-title">{title}</p>}
      {body && <p className="v2-confirm-dialog-body">{body}</p>}

      <button
        type="button"
        className={`v2-confirm-dialog-primary${danger ? " v2-confirm-dialog-primary--danger" : ""}`}
        onClick={onPrimary}
      >
        {primaryText}
      </button>

      {secondaryText && (
        <button type="button" className="v2-confirm-dialog-secondary" onClick={onSecondary || onClose}>
          {secondaryText}
        </button>
      )}
    </Dialog>
  );
}

export default ConfirmDialog;
